import React, { useState, useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import styled from 'styled-components'
import { format } from 'date-fns'

import constants from 'utils/constants'
import server from 'server/serverController2'
import { formatDate, getDatesByDay, getDateByTimezone } from 'utils/utils'

import ChallengeBanner from 'components/containers/challenge/ChallengeBanner'
import ChallengeInfo from 'components/containers/challenge/ChallengeInfo'
import ChallengeTodoList from 'components/containers/challenge/ChallengeTodoList'
import ChallengeDescription from 'components/containers/challenge/ChallengeDescription'
import ChallengeSampleProof from 'components/containers/challenge/ChallengeSampleProof'
import CampaignMainFooterJoinBtn from 'components/containers/campaign/CampaignMainFooterJoinBtn'
import CampaignInfoTab from 'components/containers/campaign/CampaignInfoTab'
import ChallengeReward from 'components/containers/challenge/ChallengeReward'
import ChallengeDetailDescription from 'components/containers/challenge/ChallengeDetailDescription'

import IntersectionChecker from 'components/containers/common/IntersectionChecker'
import LoadingModal from 'components/presenters/modal/LoadingModal'
import PersonalDataUpdateModal from 'components/containers/campaign/PersonalDataUpdateModal'
import SocialShareModal from 'components/containers/share/SocialShareModal'
import CenterModal from 'components/presenters/modal/CenterModal'
import VerticalBtnCenterModal from 'components/presenters/modal/VerticalBtnCenterModal'
import AccountFormModal from 'components/containers/campaign/AccountFormModal'

import greenCircleCheckIcon from 'images/icon/green_circle_check_icon-106×106.png'

// 모달 창 띄우기
export default function CampaignMainLayout({ targetNo, onCheckWaitingMember, onReloadReq }) {
  const userInfo = useSelector((state) => {
    return state.userInfo
  })
  const history = useHistory()

  const [challengeInfo, setChallengeInfo] = useState(null)
  const [waitingInfo, setWaitingInfo] = useState(null)
  const [socialApplyData, setSocialApplyData] = useState(null)

  const sampleMemberCount = 2
  const [sampleMember, setSampleMember] = useState([])
  const [requesting, setRequesting] = useState(false)
  const [memberNum, setMemberNum] = useState(null)
  const [maxMemberNum, setMaxMemberNum] = useState(null)
  const [todayTaskExist, setTodayTaskExist] = useState(null)

  const [initCenterModal, setInitCenterModal] = useState(false)
  const [centerModalVisible, setCenterModalVisible] = useState(false)
  const [centerModalDataList, setCenterModalDataList] = useState({})
  const [onModalComplete, setOnModalComplete] = useState(null)
  const [onModalCancel, setOnModalCancel] = useState(null)

  const [socialModalVisible, setSocialModalVisible] = useState(false)

  const [verticalBtnCenterModalVisible, setVerticalBtnCenterModalVisible] = useState(false)
  const [verticalBtnCenterModalDataList, setVerticalBtnCenterModalDataList] = useState(null)
  const [verticalBtnCenterModalBtnList, setVerticalBtnCenterModalBtnList] = useState([])
  const [verticalBtnCenterModalShowKakaoChatBtn, setVerticalBtnCenterModalShowKakaoChatBtn] =
    useState()
  const [verticalBtnCenterModalShowCloseBtn, setVerticalBtnCenterModalShowCloseBtn] = useState()
  const [initVerticalBtnCenterModal, setInitVerticalBtnCenterModal] = useState(false)

  //AccountFormModalState
  const [accountFormModalVisible, setAccountFormModalVisible] = useState(false)
  const [onAccountFormModalCallback, setOnAccountFormModalCallback] = useState(null)

  const [currTab, setCurrTab] = useState(null)

  const challengeInfoRef = useRef(null)
  const [isTabScrollMoving, setIsTabScrollMoving] = useState(false)
  const isTabScrollMovingRef = useRef()
  isTabScrollMovingRef.current = isTabScrollMoving
  const [tabId, setTabId] = useState()
  //Init Center Modal State
  useEffect(() => {
    if (initCenterModal === true) {
      setCenterModalVisible(false)
      setCenterModalDataList({})
      setOnModalComplete(null)
      setOnModalCancel(null)
      setInitCenterModal(false)
    }
  }, [initCenterModal])

  useEffect(() => {
    if (initVerticalBtnCenterModal) {
      setVerticalBtnCenterModalVisible(false)
      setVerticalBtnCenterModalDataList(null)
      setVerticalBtnCenterModalBtnList([])
      setVerticalBtnCenterModalShowCloseBtn(false)
      setVerticalBtnCenterModalShowKakaoChatBtn(false)
      setInitVerticalBtnCenterModal(false)
    }
  }, [initVerticalBtnCenterModal])

  useEffect(() => {
    if (challengeInfo) {
      loadJoinConfirmData()
    }
  }, [challengeInfo])

  useEffect(() => {
    if (challengeInfo?.rewards) {
      setCurrTab('reward')
    } else {
      setCurrTab('todolist')
    }
  }, [challengeInfo])

  useEffect(() => {
    if (isTabScrollMoving === true) {
      handleCurrTabScrollTrigger()
    }
  }, [isTabScrollMoving])

  const getCampaignInfoCallBack = (jsonData) => {
    try {
      if (jsonData.success !== 1) {
        setCenterModalVisible(true)
        setCenterModalDataList({ description: `예기치 못한 오류가 발생하였습니다.` })
        setOnModalComplete(() => () => {
          history.push('/')
          setInitCenterModal(true)
        })
        return
      }

      let receivedData = jsonData.data
      if (![null, undefined].includes(receivedData['max_capacity'])) {
        setMaxMemberNum(receivedData['max_capacity'])
      }

      let taskDateList = getDatesByDay(
        receivedData['start_date'],
        receivedData['end_date'],
        receivedData['day'],
      )
      if (receivedData['is_member'] === true) {
        if (taskDateList.includes(formatDate())) {
          setTodayTaskExist(true)
        } else {
          setTodayTaskExist(false)
        }
      }

      setMemberNum(receivedData.current_capacity)
      setChallengeInfo(receivedData)
      if (receivedData?.waiting_list === true) {
        loadWaitingListInfo()
        loadApplyData()
      }
    } catch (err) {
      console.log(err)
    }
  }

  const loadWaitingListInfo = () => {
    const currUserNo = userInfo['id']
    server.getRequestData(`campaigns/${targetNo}/waitings?user_no=${currUserNo}`, (res) => {
      if (res.success !== 1) {
        //err handling
        return
      }
      const resData = res.data
      const waitingListInfo = resData.waitings
      const targetData = waitingListInfo[0]
      if (onCheckWaitingMember) {
        onCheckWaitingMember(targetData)
      }
      setWaitingInfo(targetData)
    })
  }

  const loadApplyData = async () => {
    const currUserNo = userInfo['id']
    const response = await server.getRequestData(
      `campaigns/${targetNo}/social/applies?user_no=${currUserNo}`,
    )
    if (response['success'] !== 1) {
      return
    }
    const jsonData = response['data']
    const socialApplyData = jsonData['social_applies'][0]
    if (socialApplyData) {
      socialApplyData[
        'shared_img'
      ] = `${constants.imagePath}/campaign_social_share_img/${socialApplyData?.shared_img}`
    }
    setSocialApplyData(socialApplyData)
  }

  const loadJoinConfirmData = async () => {
    try {
      const response = await server.getRequestData(`campaigns/${targetNo}/join/confirm`)
      if (response['success'] !== 1) {
        return
      }
      const jsonData = response['data']
      const joinConfirmData = jsonData['join_confirm'][0]

      if (joinConfirmData) {
        const startDate =
          challengeInfo?.start_date &&
          format(new Date(getDateByTimezone('Asia/Seoul', challengeInfo?.start_date)), 'M/d')
        const description = startDate
          ? `참여가 승인되었어요.\n챌린지는 ${startDate}일에 시작돼요!`
          : `참여가 승인되었어요.`
        const dataList = {
          image: greenCircleCheckIcon,
          title: '참여 완료',
          description: description,
        }
        const btnList = [
          {
            text: '확인',
            onAction: () => handleConfirmApproved(),
            wrapperStyle: { background: '#FFCF19', color: '#121212' },
          },
        ]
        handleVerticalBtnCenterModal(true, dataList, btnList)
      }
      return
    } catch (err) {
      console.log('error')
      console.log(err)
    }
  }

  const handleConfirmApproved = async () => {
    try {
      const response = await server.deleteRequestData(`campaigns/${targetNo}/join/confirm`)
      if (response['success'] !== 1) {
        return
      }
      const jsonData = response['data']
      const deletedItem = jsonData['deleted_item'][0]

      if (deletedItem) {
        setInitVerticalBtnCenterModal(true)
      }
    } catch (err) {
      console.log('error')
      console.log(err)
    }
  }

  const handleVerticalBtnCenterModal = (
    visible,
    dataList,
    btnList,
    showCloseBtn,
    showKakaoChatBtn,
  ) => {
    setVerticalBtnCenterModalVisible(visible)
    setVerticalBtnCenterModalDataList(dataList)
    setVerticalBtnCenterModalBtnList(btnList)
    setVerticalBtnCenterModalShowCloseBtn(showCloseBtn)
    setVerticalBtnCenterModalShowKakaoChatBtn(showKakaoChatBtn)
  }

  const loadCampaignInfo = () => {
    const fetchArr = []
    let apiEndPoint = `campaigns/${targetNo}?show_reward=true&show_detail_description=true`
    fetchArr.push(server.getRequestData(apiEndPoint, getCampaignInfoCallBack))

    apiEndPoint = `campaigns/${targetNo}/members?limit=${sampleMemberCount}`
    fetchArr.push(
      server.getRequestData(apiEndPoint, (res) => {
        if (res?.data?.members) {
          const memberList = res.data.members
          setSampleMember(memberList)
        }
      }),
    )

    Promise.all(fetchArr)
  }

  const handleChangeTab = (tab) => {
    if (isTabScrollMovingRef.current === false) {
      setCurrTab(tab)
    }
  }

  const handleCurrTabScrollTrigger = () => {
    setTimeout(() => {
      setIsTabScrollMoving(false)
    }, 100)
    const element = document.getElementById(tabId)
    const currScrollPosition = challengeInfoRef.current.scrollTop
    const width = challengeInfoRef.current.offsetWidth
    const headerOffset = width * (150 / 375)
    const elementPosition = element.getBoundingClientRect().top
    const offsetPosition = elementPosition + currScrollPosition - headerOffset

    challengeInfoRef.current.scrollTo({
      top: offsetPosition,
    })
  }

  const onFocusHandler = () => {
    loadCampaignInfo()
  }

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    loadCampaignInfo()

    // let visibilityChange = null;
    // if (typeof document.hidden !== "undefined") { // Opera 12.10 and Firefox 18 and later support
    //   visibilityChange = "visibilitychange";
    // } else if (typeof document.msHidden !== "undefined") {
    //   visibilityChange = "msvisibilitychange";
    // } else if (typeof document.webkitHidden !== "undefined") {
    //   visibilityChange = "webkitvisibilitychange";
    // }
    // else{
    //   visibilityChange = "visibilitychange";
    // }

    // window.addEventListener(visibilityChange, onFocusHandler)

    // return function cleanup() {
    //   window.removeEventListener(visibilityChange, onFocusHandler)
    // };
  }, [])

  let bannerImg = null
  if (challengeInfo?.cover_img) {
    bannerImg = `${constants['imagePath']}/campaign_cover_img/${challengeInfo['cover_img']}`
  }

  return (
    <CampaignInner ref={challengeInfoRef}>
      <ChallengeBanner imgSrc={bannerImg} challengeInfo={challengeInfo} />
      <ChallengeInfoWrapper>
        <ChallengeInfo
          challengeInfo={challengeInfo}
          waitingInfo={waitingInfo}
          type={'campaign'}
          totalNum={memberNum}
          maxMemberNum={maxMemberNum}
          sampleMember={sampleMember}
        />
      </ChallengeInfoWrapper>
      <ChallengeInfoTabWrapper>
        <CampaignInfoTab
          isShowReward={challengeInfo?.rewards ? true : false}
          currTab={currTab}
          setCurrTab={setCurrTab}
          onChangeTab={handleChangeTab}
          onCurrTabScrollTrigger={(id) => {
            setTabId(id)
            setIsTabScrollMoving(true)
            setCurrTab(id)
          }}
        />
      </ChallengeInfoTabWrapper>

      {challengeInfo?.rewards && (
        <>
          <IntersectionChecker
            options={{ rootMargin: '-65px 0px 0px 0px' }}
            onTopIntersectOut={() => handleChangeTab('reward')}
          />
          <ChallengeRewardWrapper id={'reward'}>
            <ChallengeReward rewards={challengeInfo['rewards']} />
          </ChallengeRewardWrapper>
          <IntersectionChecker
            options={{ rootMargin: '-200px 0px 0px 0px' }}
            onTopIntersectIn={() => handleChangeTab('reward')}
          />
          <SectionDivider></SectionDivider>
        </>
      )}

      <IntersectionChecker
        options={{ rootMargin: '-200px 0px 0px 0px' }}
        onTopIntersectOut={() => handleChangeTab('todolist')}
      />
      <ChallengeTodoListWrapper id={'todolist'}>
        <ChallengeTodoList challengeInfo={challengeInfo} todayTaskExist={todayTaskExist} />
      </ChallengeTodoListWrapper>
      <IntersectionChecker
        options={{ rootMargin: '-200px 0px 0px 0px' }}
        onTopIntersectIn={() => handleChangeTab('todolist')}
      />

      <SectionDivider></SectionDivider>
      <IntersectionChecker
        options={{ rootMargin: '-200px 0px 0px 0px' }}
        onTopIntersectOut={() => handleChangeTab('sample_proof')}
      />
      <ChallengeSampleProofWrapper id={'sample_proof'}>
        <ChallengeSampleProof proofList={challengeInfo?.sample_proof} type={'campaign'} />
      </ChallengeSampleProofWrapper>
      <IntersectionChecker
        options={{ rootMargin: '-200px 0px 0px 0px' }}
        onTopIntersectIn={() => handleChangeTab('sample_proof')}
      />
      <SectionDivider></SectionDivider>
      <IntersectionChecker
        options={{ rootMargin: '-200px 0px 0px 0px' }}
        onTopIntersectOut={() => handleChangeTab('challenge_info')}
      />
      <ChallengeDescriptionWrapper id={'challenge_info'}>
        {challengeInfo?.detail_descriptions ? (
          <ChallengeDetailDescription descriptions={challengeInfo?.detail_descriptions} />
        ) : (
          <ChallengeDescription description={challengeInfo?.description} />
        )}
      </ChallengeDescriptionWrapper>
      <CampaignMainFooterJoinBtn
        campaignInfo={challengeInfo}
        waitingInfo={waitingInfo}
        socialApplyData={socialApplyData}
        onVerticalBtnCenterModal={handleVerticalBtnCenterModal}
        setInitVerticalBtnCenterModal={setInitVerticalBtnCenterModal}
        onReloadReq={() => {
          if (onReloadReq) {
            onReloadReq()
          }
          loadCampaignInfo()
        }}
        onShowPersonalDataUpdateModal={() => {
          setSocialModalVisible(true)
        }}
        onShowAccoutFormModal={(callback) => {
          setAccountFormModalVisible(true)
          setOnAccountFormModalCallback(() => callback)
        }}
      />
      {requesting && <LoadingModal />}
      <PersonalDataUpdateModal
        visible={socialModalVisible}
        setVisible={setSocialModalVisible}
        campaignNo={targetNo}
        onError={(errData) => {
          if (errData['detail_code'] === 'LOGIN_REQ') {
            setCenterModalDataList({ description: `로그인이 필요합니다.` })
            setOnModalComplete(() => () => {
              history.replace(`/social?redirect_path=/campaign/${targetNo}`)
              setInitCenterModal(true)
            })
          } else if (errData['detail_code'] === 'CAMPAIGN_ALREADY_STARTED') {
            setCenterModalDataList({ description: `이미 캠패인이 시작되었어요.` })
          } else if (errData['detail_code'] === 'BLOCKED_USER') {
            setCenterModalDataList({ description: `해당 유저는 참여가 불가능 해요.` })
          } else if (errData['detail_code'] === 'CAMPAIGN_DOES_NOT_EXIST') {
            setCenterModalDataList({ description: `해당 캠페인을 찾을 수 없어요.` })
          } else if (errData['detail_code'] === 'ALREADY_JOINED_CAMPAIGN') {
            setCenterModalDataList({ description: `해당 캠페인은 이미 참여중 이에요.` })
          } else if (errData['detail_code'] === 'EXCEEDED_MAX_CAPACITY') {
            setCenterModalDataList({ description: `참여 정원을 초과하였어요.` })
          } else {
            setCenterModalDataList({ description: `예기치 못한 오류가 발생하였습니다.` })
            setOnModalComplete(() => () => {
              history.push('/')
              setInitCenterModal(true)
            })
          }
        }}
      />
      <VerticalBtnCenterModal
        visible={verticalBtnCenterModalVisible}
        dataList={verticalBtnCenterModalDataList}
        btnList={verticalBtnCenterModalBtnList}
        setInitModal={setInitVerticalBtnCenterModal}
        showCloseBtn={verticalBtnCenterModalShowCloseBtn}
        showKakaoChatBtn={verticalBtnCenterModalShowKakaoChatBtn}
      />
      <AccountFormModal
        visible={accountFormModalVisible}
        onClose={() => setAccountFormModalVisible(false)}
        onAccountFormModalCallback={onAccountFormModalCallback}
      />
    </CampaignInner>
  )
}

const CampaignInner = styled.div`
  height: 100%;
  overflow-y: scroll;
`

const ChallengeInfoWrapper = styled.div`
  padding-top: calc(100vw * (15 / 375));
  margin-bottom: calc(100vw * (11 / 375));
`

const ChallengeRewardWrapper = styled.div``
const ChallengeInfoTabWrapper = styled.div`
  position: sticky;
  top: 0;
  background: #fff;
  display: 100%;
  padding: calc(100vw * (14 / 375)) calc(100vw * (19 / 375)) calc(100vw * (8 / 375))
    calc(100vw * (19 / 375));
  margin-bottom: calc(100vw * (15 / 375));
  z-index: 300;
`

const ChallengeTodoListWrapper = styled.div`
  margin: calc(100vw * (25 / 375)) 0;
`

const ChallengeSampleProofWrapper = styled.div`
  margin-top: calc(100vw * (25 / 375));
  margin-bottom: calc(100vw * (30 / 375));
`

const ChallengeDescriptionWrapper = styled.div`
  margin-top: calc(100vw * (25 / 375));
  margin-bottom: calc(100vw * (30 / 375));
`

const SectionDivider = styled.div`
  background: #efefef;
  height: 1px;
  margin: 0 calc(100vw * (20 / 375));
`
